<header>
    <mat-toolbar color="primary" class="mat-toolbar mat-primary mat-toolbar-single-row">
        <span class="app-toolbar-filler"></span>
        <div aria-labelledby="logo" title="Progressive Small Business" id="logo">
        </div>
    </mat-toolbar>
</header>
<section class="page-space">
    <div class="homepage-section">
        <div class="homepage-box mat-drawer-container mat-sidenav-content mat-drawer-transition">
            <div class="mat-drawer-content mat-sidenav-content">
                <div class="space-content container">
                    <ng-container *ngIf="isExpired === 'Y'; else normal;">
                        <div class="title title-basic">
                            <h2>Time out: Your session has expired.</h2>
                            <a tabindex="0" routerLink="dashboard">
                                <h4 class="link"> Please log back in Dashboard</h4>
                            </a>
                        </div>
                    </ng-container>
                    <ng-template #normal>
                        <div class="title title-basic">
                            <h2>Sign out: close browser to complete sign out.</h2>
                            <h4 class="sub-heading">You must close your browser to complete the sign out process.</h4>
                        </div>
                    </ng-template>
                </div>
            </div>
        </div>
    </div>
</section>